import { REFERENCE_TYPE_STYLES } from './reference-styles';
import { ReferenceType } from '../../../../../../../../../../../backend/src/types/types';
import { cn } from '@/new/lib/utils';

export function Reference({
  index,
  id,
  referenceType,
  onClick,
}: {
  index: number;
  id: string;
  referenceType: ReferenceType;
  onClick?: (id: string, referenceType: ReferenceType) => void;
}) {
  const style = REFERENCE_TYPE_STYLES[referenceType];
  return (
    <span
      data-kim-ref={index}
      className={cn(
        'mr-0.5 ml-0.75 inline-block -translate-y-px rounded-md border border-gray-300 bg-white px-1 font-sans text-[10px] font-normal text-gray-500',
        onClick && 'cursor-pointer',
        style.chip,
        onClick && `duration-150 ${style.chipHover}`,
      )}
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick(id, referenceType);
            }
          : undefined
      }
    >
      {index || '?'}
    </span>
  );
}
